import { getErrorMessage } from "../../../../../helper/getResponseMessage";
import axios from "../../../../../util/axiosconfig";
import { SORT_FILTER } from "../../../../../util/constants";
import { ROLES } from "../../../../../util/roleNameConstants";
import { showError, showSuccess } from "../../../../../util/ShowStatus";

export const fetchTeamLeavesData = async (
  setTeamLeaves: any,
  setTeamLeavesDataLoading: any,
  filters: any,
  sortFilter: any,
  toast: any
) => {
  try {
    setTeamLeavesDataLoading(true);
    const params: any = {
      sortField: sortFilter.sortField,
      sortOrder:
        sortFilter.sortOrder === true ? SORT_FILTER.ASC : SORT_FILTER.DESC,
    };
    if (filters) {
      if (filters.leaveType) {
        params.leaveTypeID = filters.leaveType.id;
      }
      if (filters.status) {
        params.status = filters.status;
      }
      if (filters.startDate) {
        params.startDate = filters.startDate;
      }
      if (filters.endDate) {
        params.endDate = filters.endDate;
      }
      if (filters.user) {
        params.userID = filters.user.userID;
      }
    }
    const response = await axios.get(`tl-user-leave/team-leave`, { params });
    setTeamLeaves(response.data.result);
    setTeamLeavesDataLoading(false);
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    setTeamLeavesDataLoading(false);
    showError(errorMessage, toast);
  }
};
export const fetchTimeLogUsersList = async (
  setTimeLogUsersList: any,
  toast: any
) => {
  try {
    const params: any = {};
    if (
      !localStorage.roleName.includes(ROLES.TIMELOG_ADMIN) &&
      !localStorage.roleName.includes(ROLES.TIMELOG_HR)
    ) {
      params.isLineManager = true;
    }
    const response = await axios.get(
      `tl-admin/line-manager/list?page=-1${
        params && params.isLineManager
          ? `&isLineManager=${params.isLineManager}`
          : ""
      }`
    );
    const currentUserId = localStorage.userID;
    const filteredList = response.data.result.filter(
      (user: any) => user.userID.toString() !== currentUserId.toString()
    );
    setTimeLogUsersList(filteredList);
  } catch (err) {
    const error = getErrorMessage(err);
    showError(error, toast);
  }
};

export const approveLeave = async (
  leaveHistoryID: string | null,
  managerComments: string | null,
  setIsApproveReject: any,
  setApproveRejectLoading: any,
  setManagerComments: any,
  hideComments: any,
  toast: any
) => {
  try {
    setApproveRejectLoading(true);
    const params: any = {};
    if (leaveHistoryID) {
      params.leaveHistoryID = [leaveHistoryID];
    }
    if (managerComments) {
      params.manager_comment = managerComments;
    }
    if (managerComments && hideComments === true) {
      params.hideComment = true;
    } else {
      params.hideComment = false;
    }

    const response = await axios.post(`tl-user-leave/approve-leave`, params);
    setManagerComments(null);
    setApproveRejectLoading(false);
    setIsApproveReject(false);
    showSuccess(response.data.Message, toast);
  } catch (err) {
    const error = getErrorMessage(err);
    setApproveRejectLoading(false);
    showError(error, toast);
  }
};

export const rejectLeave = async (
  leaveHistoryID: string | null,
  managerComments: string | null,
  setIsApproveReject: any,
  setApproveRejectLoading: any,
  setManagerComments: any,
  setShowManagerCommentsError: any,
  hideComments: any,
  toast: any
) => {
  try {
    if (!managerComments || managerComments.trim() === "") {
      setShowManagerCommentsError(true);
      return;
    }
    setApproveRejectLoading(true);
    const params: any = {};
    if (leaveHistoryID) {
      params.leaveHistoryID = leaveHistoryID;
    }
    if (managerComments) {
      params.manager_comment = managerComments.trim();
    }

    if (managerComments && hideComments === true) {
      params.hideComment = true;
    } else {
      params.hideComment = false;
    }
    const response = await axios.post(`tl-user-leave/reject-leave`, params);
    setManagerComments(null);
    setApproveRejectLoading(false);
    setIsApproveReject(false);
    setShowManagerCommentsError(false);
    showSuccess(response.data.Message, toast);
  } catch (err) {
    const error = getErrorMessage(err);
    setApproveRejectLoading(false);
    showError(error, toast);
  }
};

export const fetchCalendarLeaveData = async (
  setCalendarLeaveData: any,
  setCalendarLeaveDataLoading: any,
  filters: any,
  toast: any
) => {
  try {
    setCalendarLeaveDataLoading(true);
    const params: any = {};
    if (filters) {
      if (filters.leaveType) {
        params.leaveTypeID = filters.leaveType.id;
      }
      if (filters.status) {
        params.status = filters.status;
      }
      // if (filters.startDate) {
      //   params.startDate = filters.startDate;
      // }
      // if (filters.endDate) {
      //   params.endDate = filters.endDate;
      // }
      if (filters.user) {
        params.userIDs = filters.user.userID.toString();
      }
    }
    const response = await axios.get(`tl-user-leave/leave-calendar-view`, {
      params,
    });
    setCalendarLeaveData(response.data.result);
    setCalendarLeaveDataLoading(false);
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    setCalendarLeaveDataLoading(false);
    showError(errorMessage, toast);
  }
};
